export class Role {
  static readonly CREW_MEMBER = 1;
  static readonly CREW_MEMBER_PROFILE_NOT_CREATED = 11;

  static readonly CLIENT = 2;
  static readonly CLIENT_PROFILE_NOT_CREATED = 22;
}
